export default "__VITE_ASSET__1R3Hgbwh__"